import React from "react";

import "./SchoolFooterContent.css";

import SchoolFooterLinks from "./links/SchoolFooterLinks";
import SchoolFooterInfoPanel from  "./info/SchoolFooterInfoPanel";

const SchoolFooterContent = () => {
  return (
    <div className="school-footer-content">
      <SchoolFooterLinks />
      <SchoolFooterInfoPanel />
    </div>
  );
};

export default SchoolFooterContent;